import { Configuration, OpenAIApi } from "openai";
import axios from "axios";

export const callapi = async (code, selectedConversion) => {
  const configuration = new Configuration({
    //apiKey: "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",
    apiKey:"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",
  });

  console.log(
    "==========> Selected Conversion ============> ",
    selectedConversion
  );
  let engPrompt = "";
  if (selectedConversion === "JS to Python") {
    //use this while converting from JS to Python
    engPrompt = `Convert the following JavaScript code to Python, focusing on Django backend development:

  ---------------------------------
  ${code}
  ---------------------------------
  
  // 1. Libraries and Dependencies
  // Identify the libraries and dependencies used in the JavaScript code. Exclude JavaScript libraries and focus on Python libraries used in Django backend development.
  
  // 2. Language-Specific Syntax and Features
  // Take into account the differences in syntax and features between JavaScript and Python.
  
  // 3. Variable Declarations and Types
  // Handle variable declarations and types. JavaScript is dynamically typed, while Python is statically typed.
  
  // 4. Functions and Methods
  // Convert JavaScript functions and methods to their Python equivalents.
  
  // 5. Control Flow Statements
  // Translate control flow statements such as if-else, switch, for loops, while loops, etc.
  
  // 6. Error Handling
  // Consider how error handling is implemented in JavaScript and Python and ensure proper conversion.
  
  // 7. Promises and Asynchronous Operations
  // Address any asynchronous operations and JavaScript promises and provide appropriate Python alternatives.
  
  // 8. Modules and Imports
  // Handle the import and usage of modules in both JavaScript and Python. Focus on Python libraries commonly used in Django backend development.
  
  // 9. Database Operations
  // Account for any database-related operations specific to Django backend development.
  
  // 10. Additional Notes and Requirements
  // Include any additional notes or requirements specific to this code conversion task.
  
  ---------------------------------
  Finally, give me the converted code.
  `;
  } else if (selectedConversion === "Ruby on rails to JS") {
    engPrompt = `Migrate the following Ruby on Rails code to JavaScript, with a focus on generating code compatible with the React framework:

  ---------------------------------
  ${code}
  ---------------------------------

  // 1. Ruby on Rails to JavaScript Conversion
  // Convert the Ruby on Rails code to JavaScript, taking into account the following aspects:

    // 1.1 Framework and Library Migration
    // Identify the Ruby on Rails framework-specific functionality and libraries used in the code and find their equivalent JavaScript counterparts in React.

    // 1.2 Language-Specific Syntax and Features
    // Take into account the differences in syntax and features between Ruby and JavaScript, including variable declarations, object-oriented programming concepts, and language-specific constructs.

    // 1.3 Routing and URL Handling
    // Translate the routing mechanisms and URL handling used in Ruby on Rails to the appropriate routing system and URL handling mechanisms in React.

    // 1.4 Database Operations and ORM
    // Account for any database-related operations and ORM (Object-Relational Mapping) techniques specific to Ruby on Rails and find their JavaScript equivalents or suitable replacements in React.

    // 1.5 Templating and View Rendering
    // Convert the Ruby on Rails views and templates to the corresponding view rendering mechanisms in React, ensuring compatibility and proper data binding.

    // 1.6 Authentication and Authorization
    // Address any authentication and authorization mechanisms used in Ruby on Rails and find their equivalent implementations or alternatives in React.

    // 1.7 Error Handling and Logging
    // Consider the error handling and logging approaches in Ruby on Rails and adapt them to React, ensuring proper error capturing, logging, and handling.

    // 1.8 Testing and Test Framework Migration
    // Plan for the migration of tests, including unit tests, integration tests, and any Ruby on Rails-specific test frameworks, to the corresponding testing frameworks and methodologies in the React ecosystem.

    // 1.9 API Integration and External Services
    // Identify the APIs and external services used in the Ruby on Rails code and determine their JavaScript equivalents or compatible alternatives in React, ensuring seamless integration and functionality.

    // 1.10 Additional Notes and Requirements
    // Include any additional notes or requirements specific to this code migration task from Ruby on Rails to React.

  // 2. React-Specific Considerations
  // Generate JavaScript code that adheres to React best practices and takes advantage of React-specific features:

    // 2.1 React Component Structure and Hierarchy
    // Analyze the code and determine the appropriate component structure and hierarchy in React.

    // 2.2 State Management
    // Identify the state management requirements and choose the suitable state management approach in React (e.g., Redux, Context API).

    // 2.3 Event Handling and DOM Manipulation
    // Translate event handling mechanisms and DOM manipulation logic to React-specific patterns and best practices.

    // 2.4 JSX and Templating
    // Adapt the code to use JSX syntax and utilize React's templating capabilities.

    // 2.5 Lifecycle Methods and Hooks
    // Identify the usage of lifecycle methods in the code and migrate them to React's lifecycle methods or functional components with hooks.

    // 2.6 Component Styling
    // Determine the styling requirements and choose the appropriate styling approach in React (e.g., CSS-in-JS libraries, CSS modules).

    // 2.7 React Router Integration
    // If applicable, integrate React Router to handle routing in the migrated code.

    // 2.8 Testing and Test Framework Migration
    // Plan for the migration of tests, including unit tests, integration tests, and any existing Ruby on Rails-specific test frameworks, to the corresponding testing frameworks and methodologies in the React ecosystem.

    // 2.9 Additional Notes and Requirements
    // Include any additional notes or requirements specific to this code migration task from Ruby on Rails to React.

  ---------------------------------
  Finally, give me the migrated JavaScript code compatible with React.
`;
  } else if (selectedConversion === "Angular 2 to Angular 12+") {
    engPrompt = `
Convert the following Angular 2 code to Angular 12+, focusing on library migration:

---------------------------------
${code}
---------------------------------

// 1. Identify Libraries and Dependencies
// Analyze the libraries and dependencies used in the Angular 2 code. Identify the equivalent or updated libraries required for Angular 12+.

// 2. Language-Specific Syntax and Features
// Consider the differences in syntax and features between Angular 2 and Angular 12+. Highlight any breaking changes or new language features.

// 3. Component and Module Migration
// Convert Angular 2 components and modules to their Angular 12+ equivalents. Update any deprecated features or APIs.

// 4. Routing and Navigation
// Handle changes in the routing and navigation system between Angular 2 and Angular 12+. Update the routing configuration as per the latest Angular practices.

// 5. Template Syntax and Directives
// Address any changes in template syntax and directives between Angular 2 and Angular 12+. Update the code to align with the latest Angular template syntax.

// 6. Reactive Forms and Validation
// Handle changes in reactive forms and validation approaches between Angular 2 and Angular 12+. Update the code to use the latest form APIs and validation techniques.

// 7. Angular Services and Dependency Injection
// Convert Angular 2 services and dependency injection patterns to their Angular 12+ equivalents. Update any deprecated APIs or patterns.

// 8. Handling Observables and Async Operations
// Address changes in handling observables and asynchronous operations between Angular 2 and Angular 12+. Update the code to use the latest RxJS APIs and patterns.

// 9. Angular CLI and Build Configuration
// Consider changes in the Angular CLI and build configuration between Angular 2 and Angular 12+. Update the project structure and build settings accordingly.

// 10. Additional Notes and Requirements
// Include any additional notes or requirements specific to this library migration task.

---------------------------------
Finally, provide the migrated Angular 12+ code.
`;
  } else if (selectedConversion === "C++ to Java") {
    engPrompt = `
Convert the following C++ code to Java, focusing on language migration:

---------------------------------
${code}
---------------------------------

// 1. Identify Libraries and Dependencies
// Analyze the libraries and dependencies used in the C++ code. Identify the equivalent or updated libraries required in Java.

// 2. Language-Specific Syntax and Features
// Consider the differences in syntax and features between C++ and Java. Highlight any breaking changes or new language features.

// 3. Class and Object Migration
// Convert C++ classes and objects to their Java equivalents. Update any language-specific constructs or patterns.

// 4. Memory Management and Pointers
// Address changes in memory management and pointer usage between C++ and Java. Update the code to use Java's memory management mechanisms.

// 5. Input and Output
// Handle changes in input and output operations between C++ and Java. Update the code to use Java's I/O classes and methods.

// 6. Exception Handling
// Convert C++ exception handling to Java's exception handling approach. Update the code to use Java's try-catch blocks.

// 7. Standard Template Library (STL) Equivalents
// Identify C++ Standard Template Library (STL) usage and find Java equivalents or alternatives for the required functionality.

// 8. Concurrency and Threading
// Address differences in concurrency and threading mechanisms between C++ and Java. Update the code to use Java's threading features.

// 9. Additional Language-Specific Considerations
// Highlight any other language-specific considerations or challenges encountered during the C++ to Java migration.

// 10. Additional Notes and Requirements
// Include any additional notes or requirements specific to this language migration task.

---------------------------------
Finally, provide the migrated Java code.
`;
  } else if (selectedConversion === "Java to Springboot") {
    engPrompt = `Convert the following Java code to a Spring Boot application, focusing on framework migration:

    ---------------------------------
    ${code}
    ---------------------------------
    
    // 1. Identify Dependencies and Annotations
    // Analyze the libraries and dependencies used in the Java code. Identify the Spring Boot starter dependencies required for building a Spring Boot application. Also, identify annotations used for Spring framework features.
    
    // 2. Application Structure and Configuration
    // Understand the current Java application structure and configuration. Describe how the structure needs to be adapted to fit the Spring Boot project layout and configuration.
    
    // 3. Spring Bean Migration
    // Identify the Java classes that should be turned into Spring beans. Describe how these classes need to be annotated and configured in the Spring Boot application context.
    
    // 4. Data Source and Database Connectivity
    // Address changes needed for connecting to databases in a Spring Boot application. Describe how to configure data source properties and set up database connections.
    
    // 5. Web Endpoint Migration
    // Convert Java servlets, controllers, or other web endpoints to Spring MVC controllers. Describe how to use Spring annotations to define request mappings and handle HTTP requests.
    
    // 6. Dependency Injection and Autowiring
    // Highlight how dependency injection and autowiring work in Spring Boot. Describe how to inject beans and components into other classes using Spring's mechanisms.
    
    // 7. Application Properties and Configuration
    // Address changes needed for managing configuration properties. Describe how to use Spring Boot's property management to externalize configuration.
    
    // 8. Spring Boot Features and Utilities
    // Identify any Spring Boot-specific features or utilities used in the Java code. Describe their Spring Boot equivalents and usage.
    
    // 9. Exception Handling and Validation
    // Address differences in exception handling and validation mechanisms. Describe how to use Spring Boot's exception handling and validation features.
    
    // 10. Testing Strategy
    // Adapt the testing strategy for the Java code to fit the Spring Boot application. Describe how to use Spring Boot's testing utilities and annotations.
    
    // 11. Logging and Monitoring
    // Highlight changes or considerations related to logging and monitoring in a Spring Boot application.
    
    // 12. Additional Spring Boot Considerations
    // Highlight any other Spring Boot-specific considerations or challenges encountered during the migration process.
    
    // 13. Additional Notes and Requirements
    // Include any additional notes or requirements specific to this migration task.
    
    ---------------------------------
    Finally, provide the migrated Spring Boot Java code.
    `;
  } else if (selectedConversion === "Refactor the code") {
    engPrompt = `${code} \n\n Please provide a refactoring of the given code snippet to enhance its efficiency and maintainability. The code should be modularized and well-commented for clarity. Focus on best practices and separation of concerns. You can extract reusable components or functions, improve variable names, and optimize any repetitive or inefficient operations. Feel free to introduce helper functions, classes, or modules if necessary. Additionally, consider encapsulating styling into separate style objects or files for better organization. The goal is to produce clean, readable, and efficient code that adheres to best practices while retaining the original functionality.
    `;
  } else if (selectedConversion === "On Prem JS to Python") {
    let onpremOutput = "";
    let filename = "";
    if (code.includes("module.exports = Allocation;")) {
      filename = "Allocation.js";
    } else if (code.includes("const projectSchema = new")) {
      filename = "Projects.js";
    } else if (code.includes("const LoginSchema = new")) {
      filename = "LoginCreds.js";
    } else if (code.includes("const roleSchema = new")) {
      filename = "Roles.js";
    }

    onpremOutput = await cloudfunllama(filename);
    console.log("Onprem Output = ", onpremOutput);

    // Find the index where "### Response:" appears
    const responseIndex = onpremOutput.indexOf("### Response:");

    // Extract the content after "### Response:"
    const convertedPythonCode = onpremOutput.substring(responseIndex + 14);
    console.log("Onprem Converted Python code = ", convertedPythonCode);
    return convertedPythonCode;
  } else if (selectedConversion === "Teradata to Databricks"){
    engPrompt = `Convert the following Teradata code to Databricks and give me just the code

    ================================
    ${code}

    Source Code Type can be .ksh, .btq or .sql
    
    =================================
    
    **Step 1: Source Code Analysis**
    - Review the provided Teradata code and identify its primary purpose and functionality.
    - Note any specific features or dependencies unique to Teradata.
    
    **Step 2: Language and Syntax**
    - Recognize differences between Teradata and Databricks in terms of syntax, data types, and language-specific constructs.
    - Address any language-related challenges during the conversion.
    
    **Step 3: SQL Queries and Data Processing**
    - For SQL scripts (.sql and .btq files), rewrite Teradata SQL queries in Databricks SQL or equivalent syntax.
    - For shell scripts (.ksh), identify SQL-related portions and convert them to Databricks-compatible SQL.
    
    **Step 4: Control Flow and Logic**
    - Convert control flow statements (e.g., if-else, loops) to Databricks-compatible constructs.
    - Ensure that the logic and flow of the code are maintained.
    
    **Step 5: Error Handling**
    - Review error handling mechanisms in the Teradata code and adapt them to Databricks as needed.
    - Ensure that error reporting and handling are robust.
    
    **Step 6: Data Export/Import**
    - Address data export/import operations, considering Databricks' data storage and integration capabilities.
    - Update file paths and data formats as required.
    
    **Step 7: Modules and Libraries**
    - Identify any Teradata-specific modules or libraries and find equivalent or alternative libraries in Databricks.
    - Ensure proper import and usage.
    
    **Step 8: Testing and Validation**
    - Thoroughly test the converted code segments to verify correctness and functionality.
    - Pay attention to data consistency and expected outcomes.
    
    **Step 9: Additional Notes**
    - Include any additional notes or specific requirements for this code conversion task.
    
    =================================
    The reason for this conversion is to finally achieve databricks python notebook.
    So, Please proceed with the code conversion. Provide the converted Databricks-compatible code based on the analysis and considerations outlined above.

    
    `;
  }

  console.log("=================> Prompt ==============> ", engPrompt);

  const openai = new OpenAIApi(configuration);

  //this code is for using 3.5 turbo
  const response = await openai.createChatCompletion({
    //model: "text-davinci-003",
    //model:"gpt-3.5-turbo",
    model: "gpt-3.5-turbo-16k",
    messages: [{ role: "user", content: engPrompt }],
    temperature: 0,
  });
  console.log("Response = ", response);
  const convertedCode = response.data.choices[0].message.content;
  return convertedCode;
};

export const callapiPrompt = async (code, prompt) => {
  const configuration = new Configuration({
    //apiKey: "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",
    apiKey:"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"
  });

  /* let engPrompt = `Convert the following JavaScript code to Python:

        ---------------------------------
        ${code}
        ---------------------------------
        
        // 1. Libraries and Dependencies
        // Identify the libraries and dependencies used in the JavaScript code.
        
        // 2. Language-Specific Syntax and Features
        // Take into account the differences in syntax and features between JavaScript and Python.
        
        // 3. Variable Declarations and Types
        // Handle variable declarations and types. JavaScript is dynamically typed, while Python is statically typed.
        
        // 4. Functions and Methods
        // Convert JavaScript functions and methods to their Python equivalents.
        
        // 5. Control Flow Statements
        // Translate control flow statements such as if-else, switch, for loops, while loops, etc.
        
        // 6. Error Handling
        // Consider how error handling is implemented in JavaScript and Python and ensure proper conversion.
        
        // 7. Promises and Asynchronous Operations
        // Address any asynchronous operations and JavaScript promises and provide appropriate Python alternatives.
        
        // 8. Modules and Imports
        // Handle the import and usage of modules in both JavaScript and Python.
        
        // 9. DOM Manipulation and Browser-Specific Code
        // Account for any code related to the Document Object Model (DOM) and browser-specific functionality.
        
        // 10. Testing and Debugging
        // Discuss any considerations related to testing and debugging during the conversion process.
        
        // Alternative Library in Another Language:
        // If the required libraries or dependencies are not available in Python, consider alternative libraries or solutions in another language.
        
        // Additional Notes:
        // Include any additional notes or requirements specific to this code conversion task.
        
        ---------------------------------
        Finally Give me the Converted Code.
        `;*/

  let engPrompt = `${code} This is not the correct python code that I want.\n \n  ${prompt}`;

  const openai = new OpenAIApi(configuration);

  //this code is for using 3.5 turbo
  const response = await openai.createChatCompletion({
    // model: "text-davinci-003",
    //model:"gpt-3.5-turbo",
    model: "gpt-3.5-turbo-16k",
    messages: [
      {
        role: "system",
        content:
          "You are an expert in converting javascript code to python and you have knowledge of all the python libraries that can be alternatives of javascript libraries",
      },
      { role: "user", content: engPrompt },
    ],
    temperature: 0,
  });
  console.log("Response for new Prompt = ", response);
  const convertedCode = response.data.choices[0].message.content;
  return convertedCode;
};
export const callapiExplain = async (code, prompt) => {
  const configuration = new Configuration({
    //apiKey: "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",
    apiKey:"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",
  });

  /* let engPrompt = `Convert the following JavaScript code to Python:

        ---------------------------------
        ${code}
        ---------------------------------
        
        // 1. Libraries and Dependencies
        // Identify the libraries and dependencies used in the JavaScript code.
        
        // 2. Language-Specific Syntax and Features
        // Take into account the differences in syntax and features between JavaScript and Python.
        
        // 3. Variable Declarations and Types
        // Handle variable declarations and types. JavaScript is dynamically typed, while Python is statically typed.
        
        // 4. Functions and Methods
        // Convert JavaScript functions and methods to their Python equivalents.
        
        // 5. Control Flow Statements
        // Translate control flow statements such as if-else, switch, for loops, while loops, etc.
        
        // 6. Error Handling
        // Consider how error handling is implemented in JavaScript and Python and ensure proper conversion.
        
        // 7. Promises and Asynchronous Operations
        // Address any asynchronous operations and JavaScript promises and provide appropriate Python alternatives.
        
        // 8. Modules and Imports
        // Handle the import and usage of modules in both JavaScript and Python.
        
        // 9. DOM Manipulation and Browser-Specific Code
        // Account for any code related to the Document Object Model (DOM) and browser-specific functionality.
        
        // 10. Testing and Debugging
        // Discuss any considerations related to testing and debugging during the conversion process.
        
        // Alternative Library in Another Language:
        // If the required libraries or dependencies are not available in Python, consider alternative libraries or solutions in another language.
        
        // Additional Notes:
        // Include any additional notes or requirements specific to this code conversion task.
        
        ---------------------------------
        Finally Give me the Converted Code.
        `;*/

  let engPrompt = `${code} \n \n  ${prompt}`;

  const openai = new OpenAIApi(configuration);

  //this code is for using 3.5 turbo
  const response = await openai.createChatCompletion({
    // model: "text-davinci-003",
    //model:"gpt-3.5-turbo",
    model: "gpt-3.5-turbo-16k",
    messages: [
      {
        role: "system",
        content:
          "You are an expert in development, You can explain all the code written in any language. You'll act as an expert developer and code explainer and explain the code that the user provides.",
      },
      { role: "user", content: engPrompt },
    ],
    temperature: 0,
  });
  console.log("Response for Code Explanation = ", response);
  const convertedCode = response.data.choices[0].message.content;
  return convertedCode;
};

export const callconversionLikeliness = async (code, conversion) => {
  const configuration = new Configuration({
    //apiKey: "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",
    apiKey:"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",
  });

  let p = `Evaluate the code snippet provided below and give it a score according to its likelihood of being successfully converted from ${conversion}. Use a scale of 1 to 5, where 1 indicates very unlikely to be convertible, and 5 indicates very likely to be convertible. Provide your answer in the format [X/Y], where X is the score you assign and Y is the maximum possible score.`;

  let engPrompt = `${p} \n \n ${code}`;

  const openai = new OpenAIApi(configuration);

  //this code is for using 3.5 turbo
  const response = await openai.createChatCompletion({
    // model: "text-davinci-003",
    //model:"gpt-3.5-turbo",
    model: "gpt-3.5-turbo-16k",
    messages: [
      {
        role: "system",
        content:
          "You are an expert in development, You can explain all the code written in any language. You'll act as an expert developer and code explainer and explain the code that the user provides.",
      },
      { role: "user", content: engPrompt },
    ],
    temperature: 0,
  });
  console.log("Response for Conversion Likeliness = ", response);
  const scoreMessage = response.data.choices[0].message.content;
  console.log("Score Message = ", scoreMessage);

  return scoreMessage;
  //return convertedCode;
};

export const cloudfunllama = async (filename) => {
  try {
    const response = await axios.post(
      "https://us-central1-gai-ctooffice.cloudfunctions.net/llama-70B--CodeConversion",
      {
        filename: filename,
      }
    );

    if (response.status === 200) {
      console.log("Cloud function called successfully.");
      console.log(response.data);
      return response.data;
    } else {
      console.error("Cloud function call failed.");
    }
  } catch (error) {
    console.error("Error calling cloud function:", error);
  }
};

export const databricksCloudfunc = async (databricksUrl, code) => {
  try {
    const response = await axios.post(
      "https://us-central1-patientengagement-373605.cloudfunctions.net/Databricks",
      {
        databricksUrl: databricksUrl,
        code : code
      }
    );

    if (response.status === 200) {
      console.log("Cloud function called successfully.");
      console.log(response.data);
      return response.data;
    } else {
      console.error("Cloud function call failed.");
    }
  } catch (error) {
    console.error("Error calling cloud function:", error);
  }
};